import React, { useState, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import eventsEN from '../events/events_EN.json';
import eventsRU from '../events/events_RU.json';

export default function EventItems() {
  const { strings, lang_code } = useLanguage();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    // Select the correct language file
    const eventData = strings.lang_code === 'RU' ? eventsRU : eventsEN;
    const langSuffix = strings.lang_code.toLowerCase();

    // Sort by date in reverse chronological order (newest first)
    const sorted = [...eventData.events].sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );
   setEvents(sorted);
  }, [strings.lang_code]);

  return (
  <div className="content-wrapper">
  {events.map((event) => {
  return (


    <div key={event.id} className={`service-card event event-${event.type}`}>
      <div className="hero-photo" style={{ marginBottom: '20px'}}>
        <img src={event.image} alt={event.title} />
      </div>
      <div className="eyebrow">{event.type}</div>
      <h3 className="service-name" style={{ fontSize: '20px', fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, marginBottom: '12px' }}>
        {event.title}
      </h3>
      <p className="service-desc" style={{ marginBottom: '20px' }}>{event.description}</p>
      <ul className="feature-list" style={{ marginBottom: '24px' }}>
        <li><strong>{strings.pages.events.date}:</strong> {event.date}</li>
        <li><strong>{strings.pages.events.time}:</strong> {event.time}</li>
        <li><strong>{strings.pages.events.price}:</strong> {event.price}</li>
        <li><strong>{strings.pages.events.location}:</strong> {event.location}</li>
      </ul>

      <a href={event.link} className="btn-gold" style={{ width: '100%', justifyContent: 'center' }}>
        {event.cta}
      </a>
    </div>
  )})}
</div>
  );
}

